import {
    ScaleLinear, ScaleBand
  } from "d3-scale";
  import { fabric }  from "fabric";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import * as buckets from 'buckets-js'

export class PredictionPointsScatterPlot{
    xaxisValue:number
    yaxisValue:number
    path:Array<string>
    imageData: CanvasRenderingContext2D
    imageURI: string
    fabricCanvasInst: fabric.Canvas
    fabricCursorInst: fabric.StaticCanvas
    mouseCursor: any
    predictionPoints: any
    predictionIds: Array<string>

}
interface PredictionLineChart{
    xValue: number,
    yValue: number,
    defined: boolean
}
export class PredictionPointsLineChart{
    predictedPath: Array<PredictionLineChart>

}
export class ParallelCoordinateBrushObject{
    dim: any
    id: string
    xscale: any
   
}

export class ParallelCoordinatesPrediction{
    brush: buckets.LinkedList<ParallelCoordinateBrushObject>
    axes: Array<string>
    predictionPoints: Map<string, any>
    predictionLines: Map<string, string>
   

} 
export class PredictionPointsParallelCoordinates{
    axesPrediction: Array<ParallelCoordinatesPrediction>
    axesPredictionBrushes: Array<any>
    axesPredictionBrushInstanes: Map<string,any>
    axesInit: Map<string,boolean>
    htmlElements: Map<string,any>
    dimFilters: any
}

export class PredictionPointsScatterPlotArray{
   
 }


export class BrushingPointsScatterPlot{
    pointX:number;
    pointY:number;
    dataID:string
}

export class BrushingPointsBarChart{
    category:string
}

export class BrushingPointsHistogram{
    startX:number;
    endX:number;
    category:string
    thresholdArrayIds: {}
    thresholds:{}
    type:string
}

export class BrushingPointsLineChart{
    startX:number;
    endX:number;
    
}
export class BrushingLineChartAxis{
    xaxis:string;
    yaxis:string;
}


export class BrushingHistogramAxis{
    xaxis:string;
    yaxis:string;
}

export class BrushingScatterPlotAxis{
    xaxis:string;
    yaxis:string;
    linearXScale:ScaleLinear<number,number>;
    linearYScale:ScaleLinear<number,number>;
}

export class BrushingBarChartAxis{
    xaxis:string;
    yaxis:string;
}

export class PropsGraph{
    xaxis:string;
    yaxis:string;
    graphType:string
   
}


interface HistogramPredictionInterface{
    setStart(startheight: number, starty: number,  startx: number): void;
    setStop(stopheight: number, stopy: number,  startx: number): void;

}

export class HistogramPrediction implements HistogramPredictionInterface{

    startheight: number;
    startx: number;
    starty: number;
    stopheight: number;
    stopy: number;
    stopx: number;
    xaxis: string;
    yaxis: string;

    linearXScale:ScaleLinear<number,number>;
    linearYScale:ScaleLinear<number,number>;
    linearXBand:ScaleBand<string>;
    sumCategories: {};

   
    setStart(starty: number, startx: number){
        this.starty = starty
        this.startx = startx
    }
    setStop(stopy: number, stopx: number){
        this.stopy = stopy
        this.stopx = stopx
    }
    setStopHeight(stopheight: number){
        this.stopheight = stopheight
    }
    setlinearYScale(linearYScale:ScaleLinear<number,number>)
    {
        this.linearYScale = linearYScale
    }
    setlinearXScale(linearXScale:ScaleLinear<number,number>)
    {
        this.linearXScale = linearXScale
    }
    setlinearXScaleBand(linearXBand:ScaleBand<string>)
    {
        this.linearXBand = linearXBand
    }
    setSumCategories(sumCategories)
    {
        this.sumCategories = sumCategories
    }

}

export class FilterType{
    category: Set<String>
}
export class Actual{

    xaxis: string;
    yaxis: string;
    zaxis: Array<string>
    type:string;
    domainMax: number;
    domainYMax: number;
    domainXMax: number;
    domainXMin: number;
    domainYMin: number;
    height: number;
    width: number;
    brush: any;
    domainMin: number;
    graphOption: string;
    filteredValues: any;
    thresholds: Array<number>;
    thresholdArrayIds: {}
    thresholdvaluesMap: {}
    bins:Array<number>;
    categoriesIds: {}
    binsCount: number
    randomPredictSize: number
    isPredictionStarted: boolean
    filters: Map<string, FilterType>
    linearXScale:ScaleLinear<number,number>;
    linearYScale:ScaleLinear<number,number>;
    linearScalePoint:any;
    linearXBand:ScaleBand<string>;
    yAxis: any
    xAxis: any
    fabricCanvas: any
    fabricCursor: any
    mouseCursor: any
    
    sumCategories: {};
    categoriesMap: {}

   
   
    setlinearYScale(linearYScale:ScaleLinear<number,number>)
    {
        this.linearYScale = linearYScale
    }
    setlinearXScale(linearXScale:ScaleLinear<number,number>)
    {
        this.linearXScale = linearXScale
    }
    setlinearXScaleBand(linearXBand:ScaleBand<string>)
    {
        this.linearXBand = linearXBand
    }
    setSumCategories(sumCategories)
    {
        this.sumCategories = sumCategories
    }

}

export class BrushingDataSet{
    public static currentGraphID:string
    public static currentGraphType:string
    public static currentGraphActionType:string
    public static currentGraphData:any
    public static currentGraphEnable:any
    public static currentGraphBrushInstance:any
    private _actualMap:Map<string,Actual>= new Map<string,Actual>();
    private  _brushingScatterPlot:Array<BrushingPointsScatterPlot>= new Array<BrushingPointsScatterPlot>();
    private  _brushingScatterPlotAxis = new BrushingScatterPlotAxis();
    private  _brushingBarChartCategory:Set<string>= new Set<string>();
    private  _brushingBarChartAxis = new BrushingBarChartAxis();
    private  _brushingHistogram:Array<BrushingPointsHistogram>= new Array<BrushingPointsHistogram>();
    private  _brushingHistogramMap:Map<string,BrushingPointsHistogram>= new Map<string,BrushingPointsHistogram>();
    private  _brushingHistogramAxis = new BrushingHistogramAxis();
    private  _brushingLineChart:BrushingPointsLineChart= new BrushingPointsLineChart();
    private  _brushingLineChartAxis = new BrushingLineChartAxis();

    addActualID(id:string)
    {
        var actual = new Actual
        actual.filters = new Map<string, FilterType>()
        actual.zaxis = new Array<string>()
        this._actualMap.set(id, actual)
        return this._actualMap.get(id)
    }
    getActualID(id:string)
    {
        return this._actualMap.get(id)
    }
    getActualMap()
    {
        return this._actualMap
    }



    getBrushingScatterPlotAxis()
    {
        return this._brushingScatterPlotAxis
    }
    getBrushingScatterPlotArray()
    {
        return this._brushingScatterPlot
    }
    emptyBrushingScatterPlotArray()
    {
        this._brushingScatterPlot = new Array<BrushingPointsScatterPlot>();
    }




    getBrushingBarChartAxis()
    {
        return this._brushingBarChartAxis
    }
    getBrushingBarChartArray()
    {
        return this._brushingBarChartCategory
    }
    emptyBrushingBarChartArray()
    {
       this._brushingBarChartCategory.clear()
    }


    getBrushingHistogramAxis()
    {
        return this._brushingHistogramAxis
    }
    getBrushingHistogramArray()
    {
        return this._brushingHistogram
    }
    emptyBrushingHistogramArray()
    {
        this._brushingHistogram = new Array<BrushingPointsHistogram>();
    }


   
    getBrushingHistogramMap()
    {
        return this._brushingHistogramMap
    }
    emptyBrushingHistogramMap()
    {
        this._brushingHistogramMap = new Map<string,BrushingPointsHistogram>();
    }


    getBrushingLineChartAxis()
    {
        return this._brushingScatterPlotAxis
    }
    getBrushingLineChart()
    {
        return this._brushingLineChart
    }
    emptyBrushingLineChart()
    {
        this._brushingLineChart = new BrushingPointsLineChart();
    }

}




class HistogramPredictionDataset{
    private _predictionMap:Map<string,Map<string,HistogramPrediction>> = new Map<string,Map<string,HistogramPrediction>>();
    private _propsMap:Map<string,PropsGraph> = new Map<string,PropsGraph>();
    private  _initial:Map<string,boolean> = new Map<string,boolean>();
    private  _interactTop:Map<string,boolean> = new Map<string,boolean>();

    private _predictionScatterPlotMap:Map<string,PredictionPointsScatterPlot> = new Map<string,PredictionPointsScatterPlot>();
    private _predictionLineChartMap:Map<string,PredictionPointsLineChart> = new Map<string,PredictionPointsLineChart>();
    private _predictionParallelCoordinatesMap:Map<string,PredictionPointsParallelCoordinates> = new Map<string,PredictionPointsParallelCoordinates>();
   
   
    addInitial(id:string)
    {
        this._initial.set(id, null)
        return this._initial.get(id)
    }
    getInitial(id:string)
    {
        return this._initial.get(id)
    }
    setInitial(id:string, inital:boolean)
    {
        return this._initial.set(id,inital)
    }


    


    addPropsMap(id:string)
    {
        this._propsMap.set(id, new PropsGraph())
        return this._propsMap.get(id)
    }
    getPropsMap(id:string)
    {
        return this._propsMap.get(id)
    }
    getAllPropsMap()
    {
        return this._propsMap
    }

    


    
   


    addInteractTop(id:string)
    {
        this._interactTop.set(id, null)
        return this._interactTop.get(id)
    }
    getInteractTop(id:string)
    {
        return this._interactTop.get(id)
    }
    setInteractTop(id:string, inital:boolean)
    {
        return this._interactTop.set(id,inital)
    }





    addPredictionID(id:string)
    {
        this._predictionMap.set(id, new Map<string,HistogramPrediction>())
        return this._predictionMap.get(id)
    }
    getPredictionID(id:string)
    {
        return this._predictionMap.get(id)
    }
    removePrediction(id:string)
    {
        console.log('removePrediction',this._predictionMap.delete(id))
        console.log('removePrediction',this._predictionMap.get(id))
        console.log('removePrediction',this._initial.delete(id))
    }
    getPredictionMap()
    {
        return this._predictionMap
    }






    addPredictionScatterPlot(id:string)
    {
        this._predictionScatterPlotMap.set(id, new PredictionPointsScatterPlot())
        this._predictionScatterPlotMap.get(id).path = new Array<string>()
      
        return this._predictionScatterPlotMap.get(id)
    }
    getPredictionScatterPlot(id:string)
    {
        return this._predictionScatterPlotMap.get(id)
    }
    removePredictionScatterPlot(id:string)
    {
        console.log('removePrediction',this._predictionScatterPlotMap.delete(id))
        console.log('removePrediction',this._initial.delete(id))
    }
    getPredictionScatterPlotMap()
    {
        return this._predictionScatterPlotMap
    }






    addPredictionLineChart(id:string)
    {
        this._predictionLineChartMap.set(id, new PredictionPointsLineChart())
        return this._predictionLineChartMap.get(id)
    }
    getPredictionLineChart(id:string)
    {
        return this._predictionLineChartMap.get(id)
    }
    removePredictionLineChart(id:string)
    {
        console.log('removePrediction',this._predictionLineChartMap.delete(id))
        console.log('removePrediction',this._initial.delete(id))
    }
    getPredictionLineChartMap()
    {
        return this._predictionLineChartMap
    }





    addPredictionParallelCoordinatesChart(id:string)
    {
        this._predictionParallelCoordinatesMap.set(id, new PredictionPointsParallelCoordinates())
        this._predictionParallelCoordinatesMap.get(id).axesPrediction = new Array<buckets.LinkedList<ParallelCoordinatesPrediction>>()
        this._predictionParallelCoordinatesMap.get(id).axesPredictionBrushes = new Array<any>()
        this._predictionParallelCoordinatesMap.get(id).axesPredictionBrushInstanes = new Map<string,any>()
        this._predictionParallelCoordinatesMap.get(id).axesInit = new Map<string,boolean>()
        this._predictionParallelCoordinatesMap.get(id).htmlElements = new Map<string,any>()
        
        return this._predictionParallelCoordinatesMap.get(id)
    }
    getPredictionParallelCoordinatesChart(id:string)
    {
        return this._predictionParallelCoordinatesMap.get(id)
    }
    removePredictionParallelCoordinatesChart(id:string)
    {
        console.log('removePrediction',this._predictionParallelCoordinatesMap.delete(id))
        console.log('removePrediction',this._initial.delete(id))
    }
    getPredictionParallelCoordinatesCharttMap()
    {
        return this._predictionParallelCoordinatesMap
    }


}

class Dataset{
    private _attributes:Array<string>;
    private _attributes_types:Array<string>;
    private _attributes_content:Map<string,string>;
    private _keys:Array<string>;
    private _datasetMap:Map<string,string> = new Map<string,string>();
    private _datasetTypesMap:Map<string,string> = new Map<string,string>();
    private _attribute_description:Map<string,string>;
    private _records:string;


    get attributes():Array<string> {
        return this._attributes;
    }
    set attributes(attributes:Array<string>) {
        this._attributes = attributes;
    }

    get attributes_content(): Map<string,string> {
        return this._attributes_content;
    }
    set attributes_content(attributes_content: Map<string,string>) {
        this._attributes_content = attributes_content;
    }

    get records(): string {
        return this._records;
    }
    set records(records: string) {
        this._records = records;
    }

    get attribute_description(): Map<string,string> {
        return this._attribute_description;
    }
    set attribute_description(attribute_description: Map<string,string>) {
        this._attribute_description = attribute_description;
    }


    get attributes_types():Array<string> {
        return this._attributes_types;
    }
    set attributes_types(attributes_types:Array<string>) {
        this._attributes_types = attributes_types;
    }

   
    get datasetTypesMap():Map<string,string> {
        return this._datasetTypesMap;
    }
    set datasetTypesMap(attributes_types:Map<string,string>) {
        this._datasetTypesMap = attributes_types;
    }

    get datasetMap():Map<string,string> {
        return this._datasetMap;
    }
    set datasetMap(attributes:Map<string,string>) {
        this._datasetMap = attributes;
    }


    get keys():Array<string> {
        return this._keys;
    }
    set keys(keys:Array<string>) {
        this._keys = keys;
    }
}

class GraphMouse{
    private _X:number;
    private _Y:number;

    constructor(){
        this._X = 0;
        this._Y = 0;
    }

    get X():number {
        return this._X;
    }
    set X(X:number) {
        this._X = X;
    }

    get Y():number {
        return this._Y;
    }
    set Y(Y:number) {
        this._Y = Y;
    }
}


class GraphElements{
    private _graphs:any[];
    constructor(){
        this._graphs = [];
    }

    get graphs():any[] {
        return this._graphs;
    }
    set graphs(graphs:any[]) {
        this._graphs = graphs;
    }
}

class AttribuesCanvas{
    private _attributesId:string[];
    private _attributesIdMapTemp:Map<string,string>;
    private _attributesIdMapPerm:Map<string,string[]>;
    constructor(){
        this._attributesId = [];
        this._attributesIdMapTemp = new Map<string,string>();
        this._attributesIdMapPerm = new Map<string,string[]>();
    }
    get attributesId():Array<string> {
        return this._attributesId;
    }
    set attributesId(attributesId:Array<string>) {
        this._attributesId = attributesId;
    }

    get attributesIdMapTemp():Map<string,string> {
        return this._attributesIdMapTemp;
    }
   
    get attributesIdMapPerm():Map<string,string[]> {
        return this._attributesIdMapPerm;
    }
   

}
export function randomIntFromInterval(min:number,max:number) 
{
    return Math.floor(Math.random()*(max-min+1)+min);
}


class GraphSizeAtrributes{
    private _width:number;
    private _height:number;
    private _x:number;
    private _y:number;
    constructor(){
        this._width=0;
        this._height=0;
        this._x=0;
        this._y=0;
    }

    get height():number {
        return this._height;
    }
    set height(height:number) {
        this._height = height;
    }

    get width():number {
        return this._width;
    }
    set width(width:number) {
        this._width = width;
    }

    get x():number {
        return this._x;
    }
    set x(x:number) {
        this._x = x;
    }

    get y():number {
        return this._y;
    }
    set y(y:number) {
        this._y = y;
    }

   
}
class Event{
    chartID:string
    chart:string
    actionOn:string
    eventType:string
    timestamp:string
    predictionValue:any
    brusingValue:any
    xAxis:string
    yAxis:string
    zAxis:any
}

export class LogEvents{
        private _logEvents:Array<Event>
        constructor(){
            this._logEvents = new Array<Event>();
        }
        public static addEvent(chartID:string, chart:string, actionType:string, eventType:any, predictionValue:any, brusingValue: any, xAxis:string, yAxis:string, zAxis:any){
            var event = new Event()
            event.chartID = chartID
            event.chart = chart
            event.xAxis = xAxis
            event.yAxis = yAxis
            event.zAxis = zAxis
            event.actionOn = actionType
            event.eventType = eventType
            event.timestamp =  (new Date()).toISOString()
            event.predictionValue = predictionValue
            event.brusingValue = brusingValue
           return event
        }
        public getEvents(){
            return this._logEvents
        }
}
export class DatasetMode{
    private _mode: string;
    private _activeDataset: string;
    constructor(){
        this._mode="";
        this._activeDataset="";
    }

    get activeDataset():string {
        return this._activeDataset;
    }
    set activeDataset(activeDataset:string) {
        this._activeDataset = activeDataset;
    } 

    get mode():string {
        return this._mode;
    }
    set mode(mode:string) {
        this._mode = mode;
    } 
}
export var dataset:Dataset = new Dataset();
export var histogramPredictionDataset:HistogramPredictionDataset = new HistogramPredictionDataset();
export var brushingDataset:BrushingDataSet = new BrushingDataSet();

export var attributeCanvas:AttribuesCanvas = new AttribuesCanvas();
export var graphElements:GraphElements = new GraphElements();
export var graphSizeAttributes:GraphSizeAtrributes = new GraphSizeAtrributes();
export var datasetMode:DatasetMode = new DatasetMode()
export var logEventsChartIds = new Array()

graphSizeAttributes.height =  152.9
graphSizeAttributes.width = 156.8
graphSizeAttributes.x = 39.3
graphSizeAttributes.y = 4.4